import SingleEssayTablePresentation from "home/components/single_essay/presentations/single_essay_table_presentation"

export {
  SingleEssayTablePresentation
}
